import React, { useEffect, useRef, useState } from 'react'
import { PerfectMoneyDetailsApi } from '../../../api/request/wallet/deposit';
import { useSearchParams } from 'react-router-dom';

const PerfectMoney = () => {
    const formRef = useRef();
    const [searchParams, setSearchParams] = useSearchParams();
    const [formData, setFormData] = useState({})
    const getDetails = async () => {
        const paymentgetwayId = searchParams.get('paymentgetwayId');
        const CRM_OrderId = searchParams.get('CRM_OrderId');
        try {
            const { data } = await PerfectMoneyDetailsApi(paymentgetwayId, CRM_OrderId);
            if (data?.success) {
                setFormData(data?.data)
            }
        } catch (err) {

        }
    }

    useEffect(() => {
        getDetails();
    }, [])

    useEffect(() => {
        if (formData?.clientId && formData?.amount && formData?.redirectUrl && formData?.backButtonUrl) {
            formRef.current.submit();
        }
    }, [formData])



    return (
        <>
            <form action="https://perfectmoney.com/api/step1.asp" method="POST" ref={formRef} >
                <input type="hidden" name="PAYEE_ACCOUNT" value={formData?.clientId} />
                <input type="hidden" name="PAYEE_NAME" value={formData?.payeeName} />
                <input type="hidden" name="PAYMENT_ID" value={formData?.crM_OrderId} />
                <input type="hidden" name="PAYMENT_AMOUNT" value={formData?.amount} />
                <input type="hidden" name="PAYMENT_UNITS" value={formData?.paymentUnits} />
                <input type="hidden" name="STATUS_URL" value={formData?.statusUrl} />
                <input type="hidden" name="PAYMENT_URL" value={formData?.redirectUrl} />
                <input type="hidden" name="PAYMENT_URL_METHOD" value="GET" />
                <input type="hidden" name="NOPAYMENT_URL" value={formData?.backButtonUrl} />
                <input type="hidden" name="NOPAYMENT_URL_METHOD" value="GET" />
                <input type="hidden" name="SUGGESTED_MEMO" value={formData?.suggestedMemo} />
                <input type="hidden" name="V2_HASH" value={formData?.hash} />
                <input type="hidden" name="BAGGAGE_FIELDS" value="ORDER_ID CUST_EMAIL" />
                <input type="hidden" name="ORDER_ID" value={formData?.crM_OrderId} />
                <input type="hidden" name="CUST_EMAIL" value={formData?.email} />
                {/* <input type="submit" name="PAYMENT_METHOD" value="Pay Now!" /> */}
            </form>
        </>
    )
}

export default PerfectMoney